query allBasketballPlayers(
  $first: Int
  $offset: Int
  $filter: BasketballPlayerWithTeamFilter
  $condition: BasketballPlayerWithTeamCondition
) {
  players: allBasketballPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        playerId
      }
    }
    totalCount
  }
}
